import {forEach} from "lodash";
// Format maps, reverse lookup, getPixelsForFormat for layout/DPI
import {PRINT_FORMATS, getFormatAndDpiFromPixels, getPixelsForFormat} from "../../constants/print-formats.constant.js";

export class ToViewValueService {
    getArrayOfPrintingPhotos(type, mainConfig) {
        let transformed = [];
        // Guard: internalPhotos may be undefined/empty from backend
        const internalPhotos = (mainConfig[type].printFile && mainConfig[type].printFile.internalPhotos) || [];

        forEach(internalPhotos, (ph) => {
            if (ph.name.indexOf("b") === -1) {
                transformed.push({
                    width: ph.size.width,
                    height: ph.size.height,
                    x: ph.pos.topX,
                    y: ph.pos.topY,
                    angle: ph.rotation,
                    title: ph.name,
                    image: true
                });
            }
        });

        return transformed;
    }

    getStrippedPhotos(type, mainConfig) {
        let transformed = [];
        const printFile = mainConfig[type].printFile || {};

        if (!printFile.activePhotoStrip) {
            return transformed;
        }

        // Guard for internalPhotos
        const internalPhotos = printFile.internalPhotos || [];
        forEach(internalPhotos, (ph) => {
            if (ph.name.indexOf("b") !== -1) {
                transformed.push({
                    width: ph.size.width,
                    height: ph.size.height,
                    x: ph.pos.topX,
                    y: ph.pos.topY,
                    angle: ph.rotation,
                    title: ph.name,
                    image: true
                });
            }
        });

        return transformed;
    }

    getSharingPhoto(type, mainConfig) {
        let ph =  mainConfig[type].sharingFile;
        let transformed = [];
        transformed.push({
            width: ph.internalPictureSize.width,
            height: ph.internalPictureSize.height,
            x: ph.internalPicturePosition.topX,
            y: ph.internalPicturePosition.topY,
            angle: ph.internalPictureRotation,
            video: type === "boomerangBooth",
            trueVideo: type === "videoBooth",
            gif: type === "gifBooth",
            duration: mainConfig[type].playbackSpeed,
            image: type === "photoBooth"
        });

        return transformed;
    }

    /**
     * Using first photo define ratio
     * @param type
     * @returns {string}
     */
    getPhotoCaptureRatio(type, mainConfig) {
        const internalPhotos = (mainConfig[type].printFile && mainConfig[type].printFile.internalPhotos) || [];
        let ph = internalPhotos[0];

        // Guard: empty internalPhotos or missing size
        if (!ph || !ph.size) {
            return "portrait";
        }
        if (ph.size.width / ph.size.height === 1) {
            return "square";
        } else if (Math.round((ph.size.width / ph.size.height) * 10) === Math.round((2/3) * 10)) {
            return "portrait";
        } else if (Math.round((ph.size.width / ph.size.height) * 10) === Math.round((3/2) * 10)) {
            return "landscape";
        } else {
            return "custom";
        }
    }
    getLayoutCaptureRatio(type, mainConfig) {
        let ph = mainConfig[type].sharingFile;
        let settingValue = "finalSize";

        if (ph[settingValue].width / ph[settingValue].height === 1) {
            return "square";
        } else if (Math.round((ph[settingValue].width / ph[settingValue].height) * 10) === Math.round((2/3) * 10)) {
            return "portrait";
        } else if (Math.round((ph[settingValue].width / ph[settingValue].height) * 10) === Math.round((3/2) * 10)) {
            return "landscape";
        } else {
            return "custom";
        }

    }

    /**
     * Resolves layoutAspectRatio (formatId) for view: first printLayoutFormat from config,
     * else reverse lookup from finalSize. Supports A1–A6, 10×15, 15×20, 2:3, 3:2, 3:4, 4:3.
     */
    getPrintLayoutRatio(type, mainConfig) {
        const printFile = mainConfig[type].printFile || {};
        let setting = printFile.finalSize;

        if (printFile.printLayoutFormat && PRINT_FORMATS[printFile.printLayoutFormat]) {
            return printFile.printLayoutFormat;
        }

        if (!setting || !setting.width || !setting.height) {
            return "portrait";
        }

        const {formatId} = getFormatAndDpiFromPixels(setting.width, setting.height);
        return formatId;
    }

    /** Print DPI: from printFile.printDpi or reverse lookup from finalSize, fallback 300. */
    getPrintDpi(type, mainConfig) {
        const printFile = mainConfig[type].printFile || {};
        if (printFile.printDpi != null) {
            return printFile.printDpi;
        }
        const setting = printFile.finalSize;
        if (setting && setting.width && setting.height) {
            const {dpi} = getFormatAndDpiFromPixels(setting.width, setting.height);
            return dpi;
        }
        return 300;
    }

    getStartScreenValues(values) {
        let modes = ["single", "gif", "boomerang","video"];
        forEach(modes, (mode) => {
           if (values[mode]) {
               values[mode].x = typeof values[mode].x === "string" ? this.toNumber(values[mode].x) : this.transformFromPixels((values[mode].x + 0.5 * values[mode].width), 1920);
               values[mode].y = typeof values[mode].y === "string" ? this.toNumber(values[mode].y) : this.transformFromPixels((values[mode].y + 0.5 * values[mode].height), 1080);
               values[mode].width = typeof values[mode].width === "string" ? this.toNumber(values[mode].width) : this.transformFromPixels(values[mode].width, 900);
               values[mode].height = typeof values[mode].height === "string" ? this.toNumber(values[mode].height) : this.transformFromPixels(values[mode].height, 900);
           }
        });

        return values;
    }

    toNumber(val) {
        if (!val) return val;
        if (val.indexOf("-") !== -1) {
            let str = val.split("-")[0];
            return Number(str.replace(/[^0-9.]/g, ""));
        }
        return Number(val.replace(/[^0-9.]/g, ""));
    }

    transformFromPixels(val, percent) {
        let newVal = null;

        if (!val) return null;

        newVal = val / percent * 100;

        return this.roundHalf(newVal);
    }

    roundHalf(num) {
        return Math.round(num*2)/2;
    }

    detectAspectRatioObject(width, height) {
        // Перевіряємо, що width і height є числовими значеннями та більшими за нуль
        if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
            console.warn("Invalid input to detectAspectRatioObject:", width, height);
            return { w: 1, h: 1 }; // або повернути null
        }

        function gcd(a, b) {
            while (b !== 0) {
                [a, b] = [b, a % b];
            }
            return a;
        }

        const divisor = gcd(width, height);

        return {
            w: width / divisor,
            h: height / divisor
        };
    }

    transformScenes(scenes,defaultLogic = true,screen = null) {
        if (!scenes) {
            scenes = this.getDefaultScenes();
        }
        if (defaultLogic) {
            scenes.sceneLayoutAspectRatio = this.getSceneLayoutRatio(scenes.finalSize);
            if (scenes.sceneLayoutAspectRatio === "custom") {
                scenes.customLayoutHeight = scenes.pictureAspectRatio.height;
                scenes.customLayoutWidth = scenes.pictureAspectRatio.width;
            }
            scenes.layoutHeight = scenes.finalSize.height;
            scenes.layoutWidth = scenes.finalSize.width;
            scenes.photoAspectRatio = this.getSceneLayoutRatio(scenes.internalPictureSize);

            if (scenes.photoAspectRatio === "custom") {
                scenes.customPhotoHeight = scenes.pictureAspectRatio.height;
                scenes.customPhotoWidth = scenes.pictureAspectRatio.width;
            }

            scenes.photos = this.transformScenePhoto(scenes.internalPictureSize, scenes.internalPicturePosition, scenes.internalPictureRotation);

            forEach(scenes.scenesList, (s) => {
                s.sceneLayoutAspectRatio = scenes.sceneLayoutAspectRatio;
                s.customLayoutHeight = scenes.customLayoutHeight;
                s.customLayoutWidth = scenes.customLayoutWidth;
                s.layoutHeight = scenes.layoutHeight;
                s.layoutWidth = scenes.layoutWidth;
                s.photoAspectRatio = scenes.photoAspectRatio;
                s.customPhotoHeight = scenes.customPhotoHeight;
                s.customPhotoWidth = scenes.customPhotoWidth;
                s.photos = scenes.photos;
            });
        } else {
            scenes.sceneLayoutAspectRatio = this.getSceneLayoutRatio(scenes.finalSize);
            if (scenes.sceneLayoutAspectRatio === "custom") {
                scenes.customLayoutHeight = scenes.layoutAspectRatio.height;
                scenes.customLayoutWidth = scenes.layoutAspectRatio.width;
            }
            scenes.layoutHeight = screen.height;
            scenes.layoutWidth = screen.width;
            scenes.photoAspectRatio = "custom";

            if (scenes.photoAspectRatio === "custom") {
                scenes.customPhotoHeight = scenes.pictureAspectRatio.height;
                scenes.customPhotoWidth = scenes.pictureAspectRatio.width;
            }

            scenes.photos = this.transformScenePhoto(scenes.internalPictureSize, scenes.internalPicturePosition, scenes.internalPictureRotation);

            forEach(scenes.scenesList, (s) => {
                s.sceneLayoutAspectRatio = scenes.sceneLayoutAspectRatio;
                s.customLayoutHeight = scenes.customLayoutHeight;
                s.customLayoutWidth = scenes.customLayoutWidth;
                s.layoutHeight = scenes.layoutHeight;
                s.layoutWidth = scenes.layoutWidth;
                s.photoAspectRatio = scenes.photoAspectRatio;
                s.customPhotoHeight = scenes.customPhotoHeight;
                s.customPhotoWidth = scenes.customPhotoWidth;
                s.photos = scenes.photos;
            });
        }

        return scenes;
    }

    getSceneLayoutRatio(size) {
        if (size.width / size.height === 1) {
            return "square";
        } else if (Math.round((size.width / size.height) * 10) === Math.round((2/3) * 10)) {
            return "portrait";
        } else if (Math.round((size.width / size.height) * 10) === Math.round((3/2) * 10)) {
            return "landscape";
        } else {
            return "custom";
        }
    }

    transformScenePhoto(size, position, rt) {
        return [
            {
                width: size.width,
                height: size.height,
                x: position.topX,
                y: position.topY,
                image: true,
                angle: rt
            }
        ];
    }

    getDefaultScenes() {
        return {
            enabled: false,
            finalSize: {
                width: 500,
                height: 500
            },
            internalPictureSize: {
                width: 500,
                height: 500
            },
            layoutAspectRatio: {
                width: null,
                height: null
            },
            pictureAspectRatio: {
                width: null,
                height: null
            },
            internalPicturePosition: {
                topX: 0,
                topY: 0
            },
            internalPictureRotation: 0,
            scenesList: []
        };
    }

    /** Default view: printDpi 300, printCanvas from getPixelsForFormat("portrait",300) — 2:3 with 3mm bleed. */
    getDefaultViewValue() {
        const defP = getPixelsForFormat("portrait", 300);
        return {
            singlePhoto: {
                photoCaptureRatio: "custom",
                customPhotoWidth: null,
                customPhotoHeight: null,
                layoutAspectRatio: "portrait",
                printDpi: 300,
                printCanvasWidth: defP.width,
                printCanvasHeight: defP.height,
                strip: false,
                photosArr: [],
                strippedPhotosArr: [],
                digitalFormat: {
                    layoutAspectRatio: "custom",
                    photos: [{}],
                    customPhotoWidth: null,
                    customPhotoHeight: null,
                    layoutHeight: 500,
                    layoutWidth: 500
                }
            },
            gif: {
                photoCaptureRatio: "custom",
                customPhotoWidth: null,
                customPhotoHeight: null,
                layoutAspectRatio: "portrait",
                printDpi: 300,
                printCanvasWidth: defP.width,
                printCanvasHeight: defP.height,
                strip: true,
                photosArr: [],
                strippedPhotosArr: [],
                digitalFormat: {
                    layoutAspectRatio: "custom",
                    photos: [{}],
                    customPhotoWidth: null,
                    customPhotoHeight: null,
                    layoutHeight: 500,
                    layoutWidth: 500
                }
            },
            boomerang: {
                photoCaptureRatio: "custom",
                customPhotoWidth: null,
                customPhotoHeight: null,
                layoutAspectRatio: "portrait",
                printDpi: 300,
                printCanvasWidth: defP.width,
                printCanvasHeight: defP.height,
                strip: true,
                photosArr: [],
                strippedPhotosArr: [],
                digitalFormat: {
                    layoutAspectRatio: "custom",
                    photos: [{}],
                    customPhotoWidth: null,
                    customPhotoHeight: null,
                    layoutHeight: 500,
                    layoutWidth: 500
                }
            },
            video: {
                photoCaptureRatio: "custom",
                customPhotoWidth: null,
                customPhotoHeight: null,
                layoutAspectRatio: "portrait",
                printDpi: 300,
                printCanvasWidth: defP.width,
                printCanvasHeight: defP.height,
                strip: true,
                photosArr: [],
                strippedPhotosArr: [],
                digitalFormat: {
                    layoutAspectRatio: "custom",
                    photos: [{}],
                    customPhotoWidth: null,
                    customPhotoHeight: null,
                    layoutHeight: 500,
                    layoutWidth: 500
                }
            }
        };
    }

    getDefaultStartScreenAreas() {
        return {
            single: {
                width: "25vh",
                height: "25vh",
                y: "60vh",
                x: "20vw"
            },
            gif: {
                width: "25vh",
                height: "25vh",
                y: "60vh",
                x: "40vw"
            },
            boomerang: {
                width: "25vh",
                height: "25vh",
                y: "60vh",
                x: "60vw"
            },
            video: {
                width: "25vh",
                height: "25vh",
                y: "60vh",
                x: "80vw"
            }
        };
    }

    getDefaultLiveViewData() {
        return {
            enabled: true,
            forAllScenes: true,
            liveViewMode: "regular",
            liveViewPreviewSize: {
                width: 1920,
                height: 1080
            },
            liveViewBackgroundMode: "color",
            liveViewBackgroundColor: "#ffffff",
            liveViewBackground: "",
            filter: {
                enabled: true,
                liveViewBackgroundMode: "color",
                liveViewBackgroundColor: "#ffffff",
                liveViewBackground: "",
            },
            output: {
                enabled: true,
                liveViewBackgroundMode: "color",
                liveViewBackgroundColor: "#ffffff",
                liveViewBackground: "",
            },
            shouldOutputPhotoMirrored: true,
            hideOutputPictureVideo: false,
            hideSharingOptions: false,
            customButtons: {
                active:false,
                generalUiButtonsSettings:{
                    back: {width: 4.5, height: 4.5, x: 8, y: 7},
                    sharingBackBtn: {width: 3.5, height: 3.5, x: 8, y: 7},
                    capture: {width: 5.5, height: 5.5, x: 92, y: 50},
                    proceed: {width: 5.5, height: 5.5, x: 92, y: 50},
                    email: {width: 5.5, height: 5.5, x: 16.5, y: 88},
                    sms: {width: 3.5, height: 3.5, x: 35, y: 88},
                    print: {width: 3.5, height: 3.5, x: 45, y: 88},
                    done: {width: 6, height: 6, x: 89, y: 92.5},
                    qrCode: {width: 7, height: 7, x: 50, y: 11,text:"Scan me to download",textSize: 12,textColor: "black"},
                    close: {width: 3.5, height: 3.5, x: 5, y: 28},
                    next: {width: 5, height: 5, x: 93, y: 50},
                    closeError: {width: 5, height: 5, x: 93, y: 50},
                },
                captureModeButtonsSettings:{
                    single: {width: 3.5, height: 3.5, x: 8, y: 44},
                    gif: {width: 3.5, height: 3.5, x: 8, y: 49},
                    boomerang: {width: 3.5, height: 3.5, x: 8, y: 55},
                    scene: {scenePopupColor: "#FFF",width: 36, height: 48, x: 50, y: 57},
                    filter: {width: 5, height: 5, x: 8, y: 38},
                }
            }
        };
    }
}



// WEBPACK FOOTER //
// ./sources/services/configuration/to-view-value.js